import type { CreateIntentReturnRequestDto, ReturnRequestCreateIntentResponseDto } from "../generated/schema";
import { getReturnWidgetFetchClient } from "./return-widget-client";
import { usePublicApiMutation } from "./use-public-api-mutation";
import { SESSION_TOKEN_KEY } from "./use-session-token";

const authHeader = () => ({ authorization: `Bearer ${localStorage.getItem(SESSION_TOKEN_KEY) ?? ""}` });

export async function publicCreatePaymentIntent(
	body: CreateIntentReturnRequestDto,
): Promise<ReturnRequestCreateIntentResponseDto> {
	const { data, error } = await getReturnWidgetFetchClient().POST(
		"/public/return-request/checkout/create-intent",
		{ params: { header: authHeader() }, body },
	);
	if (error) throw error;
	return data;
}

export function usePublicCreatePaymentIntent() {
	return usePublicApiMutation(
		"post",
		"/public/return-request/checkout/create-intent",
		{
			mapVariables: (body: CreateIntentReturnRequestDto) => ({
				params: { header: authHeader() },
				body,
			}),
		},
	);
}
